import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFromStringDE',
  standalone: false
})
export class NumberFromStringDEPipe implements PipeTransform {
  transform(value: string): number {
    const lowerCaseValue = value.toLowerCase();

    if (lowerCaseValue.includes('m')) {
      let amount = lowerCaseValue.split('m').at(0);
      amount = amount?.replace(',', '.');
      return amount ? Number(amount) * 1000000 : 1000000;
    } else if (lowerCaseValue.includes('t') || lowerCaseValue.includes('k')) {
      const kuerzel = lowerCaseValue.includes('t') ? 't' : 'k';
      let amount = lowerCaseValue.split(kuerzel).at(0);
      amount = amount?.replace(',', '.');
      return amount ? Number(amount) * 1000 : 1000;
    } else {
      if (value.includes(',')) {
        const split = value.split(',');
        value = split[0].replaceAll('.', '') + ',' + split[1];
      } else {
        value = value.replaceAll('.', '');
      }

      if (!isNaN(Number(value.replace(',', '.')))) {
        return Number(value.replace(',', '.'));
      } else {
        return 0;
      }
    }
  }
}
